import { render, staticRenderFns } from "./MotivazioniRifiuto.vue?vue&type=template&id=dcf34432"
import script from "./MotivazioniRifiuto.vue?vue&type=script&lang=js"
export * from "./MotivazioniRifiuto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports